import { useMutation, useQueryClient } from '@tanstack/react-query';

import { saveRezeptFreeMedical, type SaveRezeptFreeMedicalPayload } from '@/services/main/rezept';
import { useClinicContext } from './useClinicContext';

/**
 * Mutation — save or clear the 自由診療 (保険外) of one 日別 treatment day.
 * Invalidates invoice list on success so 〇 appears/disappears in 保険外 column.
 */
export const useSaveRezeptFreeMedical = () => {
  const { tenant, clinicNumber } = useClinicContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ rezeptId, payload }: { rezeptId: number; payload: SaveRezeptFreeMedicalPayload }) =>
      saveRezeptFreeMedical(tenant ?? '', clinicNumber ?? '', rezeptId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['rezept-invoice', 'list'] });
    },
  });
};
